import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";

let currentUser = JSON.parse(localStorage.getItem("currentUser"));

class EditExecutive extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      techExecutiveInfo: {
        clientUserId: 0,
        clientId: 0,
        userRole: "technicalexecutive",
        userName: "",
        email: "",
        telephone: "",
        modifiedBy: currentUser.name,
        isDeleted: false,
      },
      index: 0,
      techExecutiveArray: [],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateTechExecutive = this.updateTechExecutive.bind(this);
    this.addTechExecutive = this.addTechExecutive.bind(this);
  }
  componentDidUpdate() {
    window.onpopstate = (e) => {
      //your code...
      this.props.dispatch({ type: "ShowSidePan", data: false });
      //   this.props.history.goBack();
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const { techExecutiveList, techExecutiveDetail, dispatch } = nextProps;
    if (techExecutiveDetail) {
      prevState.techExecutiveInfo.clientUserId =
        techExecutiveDetail.clientUserId;
      prevState.techExecutiveInfo.clientId = techExecutiveDetail.clientId;
      prevState.techExecutiveInfo.userName = techExecutiveDetail.userName;
      prevState.techExecutiveInfo.email = techExecutiveDetail.email;
      prevState.techExecutiveInfo.telephone = techExecutiveDetail.telephone;
      prevState.index = techExecutiveList.findIndex(
        (x) => x.email === techExecutiveDetail.email
      );
      dispatch({ type: "techExecutiveDetail", data: null });
    }
    if (techExecutiveList) {
      prevState.techExecutiveArray = techExecutiveList;
    }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "telephone") {
      const phone = e.target.validity.valid
        ? e.target.value
        : this.state.techExecutiveInfo.telephone;
      this.state.techExecutiveInfo[nodeName] = phone;
      this.setState({});
    } else {
      this.state.techExecutiveInfo[nodeName] = e.target.value;
      this.setState({});
    }
  }

  addTechExecutive() {
    const { dispatch, match,t } = this.props;
    const { params } = match;
    const { id } = params;
    let userArray = [];
    let executive = {
      clientId: id,
      userRole: "technicalexecutive",
      userName: this.state.techExecutiveInfo.userName,
      email: this.state.techExecutiveInfo.email,
      telephone: this.state.techExecutiveInfo.telephone,
      createdBy: currentUser.name,
    };
    userArray.push(executive);
    if (this.state.techExecutiveInfo.email !== "") {
      let url2 = `${API.userExist}?Mail=${this.state.techExecutiveInfo.email}`;
      axios
        .get(url2, {
          headers: {
            key: currentUser.accessToken,
          },
        })
        .then((response) => {
          if (response.data === true) {
            let url = `${API.postClientuser}`;
            axios
              .post(url, userArray, {
                headers: {
                  key: currentUser.accessToken,
                },
              })
              .then((response) => {
                let url = `${API.getClientUsers}?clientId=${id}`;
                axios
                  .get(url)
                  .then((response) => {
                    let fleetManager =
                      response.data &&
                      response.data.filter((r) => r.role === "fleetmanager");
                    let techSuperintendent =
                      response.data &&
                      response.data.filter((r) => r.role === "superintendent");
                    let techExecutive =
                      response.data &&
                      response.data.filter(
                        (r) => r.role === "technicalexecutive"
                      );
                    dispatch({
                      type: "fleetManagerListSuccess",
                      data: fleetManager,
                    });
                    dispatch({
                      type: "techSuperintendentListSuccess",
                      data: techSuperintendent,
                    });
                    dispatch({
                      type: "techExecutiveListSuccess",
                      data: techExecutive,
                    });
                    dispatch({
                      type: "getClientUsersDetailsSuccess",
                      data: response.data,
                    });
                  })
                  .catch((error) => {
                    dispatch({
                      type: "getClientUsersDetailsFailure",
                      error: "ERROR",
                    });
                  });
                this.hideSidePanel();
                dispatch({
                  type: "postClientUserDetailSuccess",
                  data: response.data,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "postClientUserDetailFailure",
                  error: "ERROR",
                });
              });
          } else if (response.data === false) {
            swal(
              "Error!",
              `${t("ShipManagementContent.UserWaringMsg")}`,
              "warning"
            );
            this.state.techExecutiveInfo.email = "";
            this.setState({});
          }
          dispatch({
            type: "getUserExistListSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "getUserExistListFailure",
            data: "error",
          });
        });
    } else {
      swal("Error!", `${t("MMPLUserManagementContent.Emailismandatory")}`, "warning");
    }
  }

  updateTechExecutive() {
    const { techExecutiveInfo, index } = this.state;
    this.state.techExecutiveArray[index] = techExecutiveInfo;
    this.setState({});
    this.props.dispatch({
      type: "techExecutiveListSuccess",
      data: this.state.techExecutiveArray,
    });
    this.hideSidePanel();
  }

  hideSidePanel() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.goBack();
  }

  render() {
    const { EditUser,t } = this.props;
    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3 ">
          <div className="w-100">
            <div className="panel-box search-filter-box">
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                onClick={() => this.hideSidePanel()}
              >
                &larr; {t("CommonText.Return")}
              </button>
              <div
                className="card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1a3464",
                    color: "white",
                  }}
                >
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    {t("ShipManagementContent.TechnicalExecutive")} 
                  </h5>
                </div>
              </div>
              <div className="row search-filter-box">
                <div className="col-lg-6">
                  <label className="form-label">N{t("EquipmentManagementScreenContent.Name")}</label>
                  <br></br>
                  <input
                    type="text"
                    className="form-control"
                    name="userName"
                    value={this.state.techExecutiveInfo.userName}
                    placeholder={t("EquipmentManagementScreenContent.Name")}
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-6">
                  <label className="form-label">{t("ServicedByScreenContent.Email")}</label>
                  <br></br>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={this.state.techExecutiveInfo.email}
                    placeholder={t("ServicedByScreenContent.Email")}
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                </div>
                <div className="col-lg-6">
                  <label className="form-label">{t("ClientManagementScreenContent.Phone")}</label>
                  <br></br>
                  <input
                    type="text"
                    className="form-control"
                    pattern="[0-9]*"
                    name="telephone"
                    value={this.state.techExecutiveInfo.telephone}
                    placeholder={t("ClientManagementScreenContent.Phone")}
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 search-filter-box">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    {!EditUser ? (
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.addTechExecutive()}
                      >
                        {" "}
                        {t("ShipManagementContent.Add")}{" "}
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.updateTechExecutive()}
                      >
                        {" "}
                        {t("EquipmentServiceTypes.Update")}{" "}
                      </button>
                    )}
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.hideSidePanel()}
                    >
                      {" "}
                      {t("ComplianceandBudgetScreen.Cancel")}{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    techExecutiveList: state.MasterScreenReducer.techExecutiveList,
    techExecutiveDetail: state.MasterScreenReducer.techExecutiveDetail,
    EditUser: state.MasterScreenReducer.EditUser,
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EditExecutive)
));
